/* eslint-disable react/no-danger */
import React from "react";
import "../../css/footer.scss";

const Footer = () => (
  <div className="footer-full">
    <div className="footer">
      <h2>
        The Orientation Edition <br />
        <span className="daily-title">from The Michigan Daily</span>
      </h2>
    </div>
    <div className="social-icons">
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.facebook.com/michigandaily/"
        className="social-icon"
      >
        <i className="fa fa-facebook" aria-hidden="true" />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://twitter.com/michigandaily/"
        className="social-icon"
      >
        <i className="fa fa-twitter" aria-hidden="true" />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.instagram.com/michigandaily/"
        className="social-icon"
      >
        <i className="fab fa-instagram" aria-hidden="true" />
      </a>
    </div>

    <div className="copyright-row">
      <h2>Copyright © 2022, all rights reserved</h2>
    </div>
  </div>
);

export default Footer;
